import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Importar Bootstrap
import { Modal, Button, Form } from 'react-bootstrap'; // Importar componentes de Bootstrap

const ListaHorasSinCierre = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [respuesta, setRespuesta] = useState(null);
  const [fechaSeleccionada, setFechaSeleccionada] = useState('');
  const [fechaSeleccionada2, setFechaSeleccionada2] = useState('');
  const [paginaActual, setPaginaActual] = useState(1);
  const [itemsPorPagina] = useState(1000); // Número de elementos por página
  const [filtroNombre, setFiltroNombre] = useState(''); // Estado para filtrar por nombre
  const [filtroCompania, setFiltroCompania] = useState(''); // Estado para filtrar por compañía
  const [filtroUnidad, setFiltroUnidad] = useState(''); // Estado para filtrar por unidad
  const [filtroPuesto, setFiltroPuesto] = useState('');  // Estado para filtrar por puesto
  const [filtroArea, setFiltroArea] = useState(''); // Estado para filtrar por unidad
  const [filtroCodigo, setFiltroCodigo] = useState('');
  const [showModal, setShowModal] = useState(false); // Estado para controlar la visibilidad del modal de modificación
  const [showModalInsertar, setShowModalInsertar] = useState(false); // Estado para controlar la visibilidad del modal de inserción
  const [marcajeSeleccionado, setMarcajeSeleccionado] = useState(null); // Estado para almacenar el marcaje seleccionado
  const [empleados, setEmpleados] = useState([]); // Estado para almacenar la lista de empleados
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null); // Estado para almacenar el empleado seleccionado
  const [nuevoMarcaje, setNuevoMarcaje] = useState({
    checktime_in: '',
    checktime_out: '',
  });
  const [filtroBusqueda, setFiltroBusqueda] = useState(''); // Estado para el filtro de búsqueda

  // Estado para almacenar los datos del nuevo marcaje

  // Función para abrir el modal de inserción
  const handleAbrirModalInsertar = () => {
    setShowModalInsertar(true);
    // Aquí podrías cargar la lista de empleados desde una API
    setFiltroBusqueda('');
  };

  // Función para cerrar el modal de inserción
  const handleCerrarModalInsertar = () => {
    setShowModalInsertar(false);
    setEmpleadoSeleccionado(null);
    setNuevoMarcaje({ checktime_in: '', checktime_out: '' });
  };

  // Función para manejar la selección de un empleado
  const handleSeleccionarEmpleado = (empleado) => {
    setEmpleadoSeleccionado(empleado);
  };

  const obtenerEmpleados = async () => {
    try {
      const response = await fetch('URL_DE_TU_API_PARA_OBTENER_EMPLEADOS');
      const data = await response.json();
      setEmpleados(data); // Asume que la API devuelve un array de empleados
    } catch (error) {
      console.error('Error al obtener la lista de empleados:', error);
    }
  };
  // Función para manejar el envío del nuevo marcaje
  const handleInsertarMarcaje = async () => {
    if (!empleadoSeleccionado) {
      setError('Por favor, selecciona un empleado.');
      return;
    }

    const datosModificados = {
      id: empleadoSeleccionado.id,
      CodEmp: empleadoSeleccionado.codigo,
      checktime_in: nuevoMarcaje.checktime_in,
      checktime_out: nuevoMarcaje.checktime_out,
      Tipo: 'I'
    };

    try {
      // Enviar los cambios al API
      const respuesta = await enviarCambiosAlAPI(datosModificados);
      console.log('Marcaje insertado exitosamente:', respuesta);
      setRespuesta('');
      enviarDatos();
      alert('Marcaje insertado correctamente');

      // Cerrar el modal
      handleCerrarModalInsertar();
    } catch (error) {
      console.error('Error al insertar el marcaje:', error);
      setError('Error al insertar el marcaje. Por favor, inténtalo de nuevo.');
    }
  };

  const enviarDatos = async () => {
    setLoading(true);
    setError(null);
    setRespuesta(null);
  
    if (!fechaSeleccionada) {
      setError('Por favor, selecciona una fecha.');
      setLoading(false);
      return;
    }
  
    const fechaFormateada = fechaSeleccionada.replace(/-/g, '');
    const fechaFormateada2 = fechaSeleccionada2.replace(/-/g, '');
    const datos = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      Usr: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      DatosMetodo: {
        NombreMetodo: 'ObtenerListaMarcasSinCierre',
        Datos_Recibidos: JSON.stringify({ FechaIni: fechaFormateada, FechaFin: fechaFormateada2 }),
      },
    };
  
    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(datos)
    )}`;
  
    try {
      const response = await fetch(fetchDataUrl);
      const data = await response.json();
      console.log('Respuesta de la API:', data);
  
      if (data.datos_Generados) {
        const datosGenerados = JSON.parse(data.datos_Generados);
        console.log('Datos Generados (JSON):', datosGenerados);
  
        if (typeof datosGenerados.MARCAS_SIN_CIERRE === 'string') {
          datosGenerados.MARCAS_SIN_CIERRE = JSON.parse(datosGenerados.MARCAS_SIN_CIERRE);
        }
  
        // Extraer la lista de empleados únicos
        const empleadosUnicos = datosGenerados.MARCAS_SIN_CIERRE.reduce((acc, marcaje) => {
          const codigo = marcaje.exp_codigo_alternativo;
          if (!acc[codigo]) {
            acc[codigo] = {
              id: marcaje.exp_codigo_alternativo,
              nombre: marcaje.exp_apellidos_nombres,
              codigo: marcaje.exp_codigo_alternativo,
            };
          }
          return acc;
        }, {});
  
        setEmpleados(Object.values(empleadosUnicos)); // Almacenar la lista de empleados en el estado
  
        // Agrupar los datos por exp_codigo_alternativo
        const datosAgrupados = datosGenerados.MARCAS_SIN_CIERRE.reduce((acc, marcaje) => {
          const codigo = marcaje.exp_codigo_alternativo;
          if (!acc[codigo]) {
            acc[codigo] = [];
          }
          acc[codigo].push(marcaje);
          return acc;
        }, {});
  
        setRespuesta(datosAgrupados);
        console.log(datosAgrupados);
      } else {
        setError('No se encontraron datos generados en la respuesta.');
      }
    } catch (error) {
      console.error('Error al procesar la respuesta:', error);
      setError('Error al procesar la respuesta de la API.');
    } finally {
      setLoading(false);
    }
  };

  // Calcular los índices de los elementos a mostrar
  const indexUltimoItem = paginaActual * itemsPorPagina;
  const indexPrimerItem = indexUltimoItem - itemsPorPagina;

  // Filtrar los datos por nombre, compañía, unidad y puesto
  const datosFiltrados = respuesta
    ? Object.values(respuesta)
        .flat()
        .filter((marcaje) => {
          const coincideNombre = marcaje.exp_apellidos_nombres
            .toLowerCase()
            .includes(filtroNombre.toLowerCase());
          const coincideCompania = marcaje.cia_descripcion
            .toLowerCase()
            .includes(filtroCompania.toLowerCase());
          const coincideUnidad = marcaje.uni_descripcion
            .toLowerCase()
            .includes(filtroUnidad.toLowerCase());
          const coincidePuesto = marcaje.pue_nombre
            .toLowerCase()
            .includes(filtroPuesto.toLowerCase());
         const coincideCodigo = marcaje.exp_codigo_alternativo
            .toLowerCase()
            .includes(filtroCodigo.toLowerCase()); 
        const coincideArea = marcaje.arf_nombre
            .toLowerCase()
            .includes(filtroArea.toLowerCase());    
  

          return (
            coincideNombre && coincideCompania && coincideUnidad && coincidePuesto && coincideCodigo && coincideArea
          );
        })
    : [];

  const itemsActuales = datosFiltrados.slice(indexPrimerItem, indexUltimoItem);

  // Cambiar de página
  const cambiarPagina = (numeroPagina) => setPaginaActual(numeroPagina);

  // Abrir modal y establecer el marcaje seleccionado
  const handleModificar = (marcaje) => {
    setMarcajeSeleccionado(marcaje);
    setShowModal(true);
  };

  // Cerrar modal
  const handleCerrarModal = () => {
    setShowModal(false);
    setMarcajeSeleccionado(null);
  };

  const enviarCambiosAlAPI = async (marcajeModificado) => {
    const datosParaEnviar = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      User: {
        Codigo: "",
        UserNickName: "pierril",
      },
      Metodo: {
        NombreMetodo: "GenerarCierreMarca",
        Datos_Recibidos: JSON.stringify(marcajeModificado), // Datos modificados del marcaje
        Datos_Generados: "",
      },
    };
    console.log(datosParaEnviar)
    try {
      const response = await fetch("https://appcorp.parma.com.gt/API/ReceptorDatos", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(datosParaEnviar),
      });

      if (!response.ok) {
        throw new Error(`Error en la petición: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Respuesta del API:", data);
      return data; // Retorna la respuesta del API
    } catch (error) {
      console.error("Error al enviar los cambios al API:", error);
      throw error; // Lanza el error para manejarlo en el componente
    }
  };

  const ActulizacionHoraSalida = async () => {
    const fechaFormateada = fechaSeleccionada.replace(/-/g, '');
    const fechaFormateada2 = fechaSeleccionada2.replace(/-/g, '');

    const datosParaEnviar = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      User: {
        Codigo: "",
        UserNickName: "pierril",
      },
      Metodo: {
        NombreMetodo: "CerrarEdicionMarcas",
        Datos_Recibidos: JSON.stringify({ FechaIni: fechaFormateada, FechaFin: fechaFormateada2 }), // Datos modificados del marcaje
        Datos_Generados: "",
      },
    };
    console.log(datosParaEnviar)
    try {
      const response = await fetch("https://appcorp.parma.com.gt/API/ReceptorDatos", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(datosParaEnviar),
      });

      if (!response.ok) {
        throw new Error(`Error en la petición: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Respuesta del API:", data);
      setRespuesta("");
      enviarDatos();
      return data; // Retorna la respuesta del API
    } catch (error) {
      console.error("Error al enviar los cambios al API:", error);
      throw error; // Lanza el error para manejarlo en el componente
    }
  };

  const handleGuardarCambios = async () => {
    if (!marcajeSeleccionado) return;

    // Construir el JSON con los datos modificados
    const datosModificados = {
      id: marcajeSeleccionado.id,
      CodEmp: marcajeSeleccionado.exp_codigo_alternativo,
      checktime_in: marcajeSeleccionado.checktime_in,
      checktime_out: marcajeSeleccionado.checktime_out,
    };

    try {
      // Enviar los cambios al API
      const respuesta = await enviarCambiosAlAPI(datosModificados);
      console.log("Cambios guardados exitosamente:", respuesta);
      setRespuesta("");
      enviarDatos();
      alert("Cambio exitoso");

      // Cerrar el modal
      handleCerrarModal();
    } catch (error) {
      console.error("Error al guardar los cambios:", error);
      // Mostrar un mensaje de error al usuario
      setError("Error al guardar los cambios. Por favor, inténtalo de nuevo.");
    }
  };

  return (
    <div className="container mt-5">
      <h1 className="mb-4">Lista de Marcas sin Cierre</h1>

      {/* Selector de fechas y botón en una sola línea */}
      <div className="d-flex align-items-end mb-3 gap-2">
        <div className="me-2">
          <label className="form-label">
            Fecha Inicio:
            <input
              type="date"
              className="form-control"
              value={fechaSeleccionada}
              onChange={(e) => setFechaSeleccionada(e.target.value)}
            />
          </label>
        </div>
        <div className="me-2">
          <label className="form-label">
            Fecha Fin:
            <input
              type="date"
              className="form-control"
              value={fechaSeleccionada2}
              onChange={(e) => setFechaSeleccionada2(e.target.value)}
            />
          </label>
        </div>
        <div className="col-sm-3">
          <button
            className="btn btn-primary"
            onClick={enviarDatos}
            disabled={loading}
          >
            {loading ? 'Cargando...' : 'Obtener Marcajes'}
          </button>
        </div>
        <div className="col col-lg-2">
          <button
            className="btn btn-danger"
            onClick={ActulizacionHoraSalida}
            disabled={loading}
          >
            {loading ? 'Cargando...' : 'Cerrar Horas '}
          </button>
        </div>
        <div className="col col-lg-2">
          <button
            className="btn btn-success"
            onClick={handleAbrirModalInsertar}
            disabled={loading}
          >
            {loading ? 'Cargando...' : 'Insertar Marcaje'}
          </button>
        </div>
      </div>

      {/* Filtros principales */}
      <div className="row mb-3">
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por nombre"
            value={filtroNombre}
            onChange={(e) => setFiltroNombre(e.target.value)}
          />
        </div> 
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por Codigo"
            value={filtroCodigo}
            onChange={(e) => setFiltroCodigo(e.target.value)}
          />
        </div>

        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por compañía"
            value={filtroCompania}
            onChange={(e) => setFiltroCompania(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por unidad"
            value={filtroUnidad}
            onChange={(e) => setFiltroUnidad(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por Puesto"
            value={filtroPuesto}
            onChange={(e) => setFiltroPuesto(e.target.value)}
          />
        </div>  
        <div className="col-md-2">
          <input
            type="text"
            className="form-control"
            placeholder="Filtrar por Area"
            value={filtroArea}
            onChange={(e) => setFiltroArea(e.target.value)}
          />
        </div> 

      </div>

      {/* Mostrar errores */}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Mostrar los datos agrupados en una tabla */}
      {respuesta && (
        <div>
          <h2>Datos Agrupados:</h2>
          <table className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th>Código Empleado</th>
              
                <th>Unidad</th>
                <th>Puesto</th>
                <th>Area</th>
                <th>Nombre</th>
                <th>Fecha</th>
                <th>Hora de Marcaje</th>
                <th>Hora de Marcaje Salida</th>
                <th>Tiempo Minutos</th>
                <th>Tiempo Horas</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {itemsActuales.map((marcaje, index) => (
                <tr
                  key={index}
                  className={marcaje.checktime_out ? "table-success" : ""} // Aplica la clase "table-success" si checktime_out existe
                >
                  <td>{marcaje.exp_codigo_alternativo}</td> 
                 
                  <td>{marcaje.uni_descripcion}</td> 
                  <td>{marcaje.pue_nombre}</td> 
                  <td>{marcaje.arf_nombre}</td> 
                  <td>{marcaje.exp_apellidos_nombres}</td>
                  <td>{marcaje.Fecha}</td>
                  <td>{marcaje.checktime_in}</td>
                  <td>{marcaje.checktime_out}</td>
                  <td>{marcaje.TiempoMinutos}</td>
                  <td>{marcaje.TiempoHoras}</td>
                  <td>
                    <button
                      className="btn btn-warning btn-sm"
                      onClick={() => handleModificar(marcaje)}
                    >
                      Modificar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Paginación */}
          <nav>
            <ul className="pagination">
              {Array.from({ length: Math.ceil(datosFiltrados.length / itemsPorPagina) }, (_, i) => (
                <li key={i} className={`page-item ${paginaActual === i + 1 ? 'active' : ''}`}>
                  <button className="page-link" onClick={() => cambiarPagina(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      )}

      {/* Modal para modificar */}
      <Modal show={showModal} onHide={handleCerrarModal}>
        <Modal.Header closeButton>
          <Modal.Title>Modificar Marcaje</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {marcajeSeleccionado && (
            <Form>
              <Form.Group controlId="formNombre">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  type="text"
                  value={marcajeSeleccionado.exp_apellidos_nombres}
                  readOnly
                />
              </Form.Group>
              <Form.Group controlId="formCodigo">
                <Form.Label>Código de Empleado</Form.Label>
                <Form.Control
                  type="text"
                  value={marcajeSeleccionado.exp_codigo_alternativo}
                  readOnly
                />
              </Form.Group>
              <Form.Group controlId="formChecktimeIn">
                <Form.Label>Hora de Entrada</Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={marcajeSeleccionado.checktime_in}
                  onChange={(e) =>
                    setMarcajeSeleccionado({
                      ...marcajeSeleccionado,
                      checktime_in: e.target.value,
                    })
                  }
                />
              </Form.Group>
              <Form.Group controlId="formChecktimeOut">
                <Form.Label>Hora de Salida</Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={marcajeSeleccionado.checktime_out}
                  onChange={(e) =>
                    setMarcajeSeleccionado({
                      ...marcajeSeleccionado,
                      checktime_out: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Form>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCerrarModal}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={handleGuardarCambios}>
            Guardar Cambios
          </Button>
        </Modal.Footer>
      </Modal> 

      {/* Modal de inserción */}
      <Modal show={showModalInsertar} onHide={handleCerrarModalInsertar}>
  <Modal.Header closeButton>
    <Modal.Title>Insertar Marcaje</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      {/* Campo de búsqueda */}
      <Form.Group controlId="formBusqueda">
        <Form.Label>Buscar Empleado</Form.Label>
        <Form.Control
          type="text"
          placeholder="Buscar por nombre o código..."
          value={filtroBusqueda}
          onChange={(e) => setFiltroBusqueda(e.target.value)}
        />
      </Form.Group>

      {/* Select de empleados filtrados */}
      <Form.Group controlId="formEmpleado">
        <Form.Label>Seleccionar Empleado</Form.Label>
        <Form.Control
          as="select"
          value={empleadoSeleccionado ? empleadoSeleccionado.id : ''}
          onChange={(e) => {
            const empleado = empleados.find(emp => emp.id === e.target.value);
            setEmpleadoSeleccionado(empleado);
          }}
        >
          <option value="">Selecciona un empleado</option>
          {empleados
            .filter((empleado) => {
              const nombre = empleado.nombre.toLowerCase();
              const codigo = empleado.codigo.toLowerCase();
              const busqueda = filtroBusqueda.toLowerCase();
              return nombre.includes(busqueda) || codigo.includes(busqueda);
            })
            .map((empleado) => (
              <option key={empleado.id} value={empleado.id}>
                {empleado.nombre} ({empleado.codigo})
              </option>
            ))}
        </Form.Control>
      </Form.Group>

      {/* Campos para la hora de entrada y salida */}
      <Form.Group controlId="formChecktimeIn">
        <Form.Label>Hora de Entrada</Form.Label>
        <Form.Control
          type="datetime-local"
          value={nuevoMarcaje.checktime_in}
          onChange={(e) =>
            setNuevoMarcaje({ ...nuevoMarcaje, checktime_in: e.target.value })
          }
        />
      </Form.Group>
      <Form.Group controlId="formChecktimeOut">
        <Form.Label>Hora de Salida</Form.Label>
        <Form.Control
          type="datetime-local"
          value={nuevoMarcaje.checktime_out}
          onChange={(e) =>
            setNuevoMarcaje({ ...nuevoMarcaje, checktime_out: e.target.value })
          }
        />
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleCerrarModalInsertar}>
      Cerrar
    </Button>
    <Button variant="primary" onClick={handleInsertarMarcaje}>
      Insertar
    </Button>
  </Modal.Footer>
</Modal>
    </div>
  );
};

export default ListaHorasSinCierre;